export default {
  sections: [
    {
      id: 'inspector',
      title: 'Registered Inspector\'s Details',
      fields: [
        { id: 'name', type: 'text', label: 'Name', required: true },
        { id: 'address', type: 'textarea', label: 'Address', required: true },
        { id: 'postCode', type: 'text', label: 'Post Code', required: true },
        { id: 'tel', type: 'tel', label: 'Telephone', required: true },
        { id: 'gasRegNumber', type: 'text', label: 'Gas Safe Reg No.', required: true, placeholder: 'e.g. 183033' }
      ]
    },
    {
      id: 'inspectionAddress',
      title: 'Inspection Address',
      fields: [
        { id: 'name', type: 'text', label: 'Name' },
        { id: 'address', type: 'textarea', label: 'Address', required: true },
        { id: 'postCode', type: 'text', label: 'Post Code', required: true },
        { id: 'tel', type: 'tel', label: 'Telephone' },
        { id: 'tenantName', type: 'text', label: 'Tenant\'s Name' },
        { id: 'tenantPresent', type: 'select', label: 'Present', options: ['YES', 'NO'] }
      ]
    },
    {
      id: 'landlord',
      title: 'Landlord Details',
      fields: [
        { id: 'name', type: 'text', label: 'Name', required: true },
        { id: 'address', type: 'textarea', label: 'Address', required: true },
        { id: 'postCode', type: 'text', label: 'Post Code', required: true },
        { id: 'tel', type: 'tel', label: 'Telephone' }
      ]
    },
    {
      id: 'appliances',
      title: 'Appliance Details & Inspection',
      repeatable: true,
      fields: [
        // Basic Appliance Details
        { id: 'location', type: 'text', label: 'Location', required: true, placeholder: 'e.g. Kitchen, Living Room' },
        { id: 'type', type: 'select', label: 'Type', required: true, 
          options: ['Boiler', 'Fire', 'Cooker', 'Hob', 'Water Heater', 'Other'] },
        { id: 'make', type: 'text', label: 'Make', placeholder: 'e.g. Worcester Bosch' },
        { id: 'model', type: 'text', label: 'Model', placeholder: 'e.g. Greenstar 30CDi' },
        { id: 'flueType', type: 'select', label: 'Flue Type',
          options: ['RS (Room Sealed)', 'OF (Open Flue)', 'FL (Flueless)', 'CF (Conventional Flue)', 'N/A'] },
        
        // Inspection Details
        { id: 'operatingPressure', type: 'text', label: 'Operating Pressure (mbar/kg/hr)' },
        { id: 'heatInputActual', type: 'text', label: 'Heat Input Actual (kW)' },
        { id: 'gasRateMeterReading', type: 'number', label: 'Meter Reading (m³/ft³) over test period' },
        { id: 'gasRateSeconds', type: 'number', label: 'Test Duration (seconds)', placeholder: '120' },
        { id: 'meterUnit', type: 'select', label: 'Meter Unit', options: ['metric (m³)', 'imperial (ft³)'] },
        { id: 'meterPressure', type: 'number', label: 'Meter Pressure (mbar)', placeholder: '21' },
        { id: 'appliancePressure', type: 'number', label: 'Appliance Operating Pressure (mbar)', placeholder: '20.2' },
        { id: 'smokeMatchSpillage', type: 'select', label: 'Smoke Match Spillage Test', 
          options: ['Pass', 'Fail', 'N/A'] },
        { id: 'smokeMatchVentilation', type: 'select', label: 'Smoke Match Ventilation Test', 
          options: ['Pass', 'Fail', 'N/A'] },
        { id: 'flueTerminationSatisfactory', type: 'select', label: 'Satisfactory Flue Termination', 
          options: ['Yes', 'No', 'N/A'] },
        { id: 'visualCondition', type: 'select', label: 'Visual Condition', 
          options: ['Pass', 'Fail'] },
        { id: 'adequateVentilation', type: 'select', label: 'Adequate Ventilation', 
          options: ['Yes', 'No', 'N/A'] },
        { id: 'applianceSafeToUse', type: 'select', label: 'Appliance Safe to Use', 
          options: ['Yes', 'No'], required: true },
        { id: 'landlordsAppliance', type: 'select', label: 'Landlord\'s Appliance', 
          options: ['Yes', 'No'] },
        { id: 'inspected', type: 'select', label: 'Inspected', 
          options: ['Yes', 'No'], required: true },

        // Flue Gas Combustion Analysis (BS 7967)
        { id: 'combustionAnalysisDone', type: 'select', label: 'Combustion Analysis Performed', 
          options: ['Yes', 'No'] },
        { id: 'coPpm', type: 'number', label: 'CO (ppm)', placeholder: 'e.g. 40' },
        { id: 'co2Pct', type: 'number', label: 'CO₂ (%)', placeholder: 'e.g. 9.5' },
        { id: 'o2Pct', type: 'number', label: 'O₂ (%)', placeholder: 'e.g. 4' },
        { id: 'flueGasTempC', type: 'number', label: 'Flue Gas Temperature (°C)' },
      ]
    },
    {
      id: 'soundnessTest',
      title: 'Gas Installation Soundness Test',
      fields: [
        { id: 'result', type: 'select', label: 'Test Result', required: true, 
          options: ['Pass', 'Fail'] },
        { id: 'warningNoticeIssued', type: 'select', label: 'Warning Notice Issued', 
          options: ['Yes', 'No', 'N/A'] },
        { id: 'warningStickerFitted', type: 'select', label: 'Warning Tag or Sticker Fitted', 
          options: ['Yes', 'No', 'N/A'] }
      ]
    },
    {
      id: 'faultsAndRectification',
      title: 'Give Details of All Faults and Rectification Work Required',
      fields: [
        { id: 'details', type: 'textarea', label: 'Fault Details', 
          placeholder: 'Describe any faults found and work required' }
      ]
    },
    {
      id: 'certification',
      title: 'Certification',
      fields: [
        { id: 'numberOfAppliances', type: 'number', label: 'Number of Appliances Tested', required: true },
        { id: 'nextCheckMonths', type: 'number', label: 'Next Gas Safety Check Must Be Carried Out Within (Months)', 
          required: true, placeholder: '12' },
        { id: 'inspectionDate', type: 'date', label: 'Inspection Date', required: true },
        { id: 'certificateNumber', type: 'text', label: 'Certificate Number', required: true },
        { id: 'engineerSignature', type: 'signature', label: 'Engineer Signature', required: true },
        { id: 'engineerPrintName', type: 'text', label: 'Print Name', required: true }
      ]
    },
    {
      id: 'landlordReceipt',
      title: 'Received on Behalf of the Landlord',
      fields: [
        { id: 'signature', type: 'signature', label: 'Signature' },
        { id: 'recipientType', type: 'select', label: 'Tenant/Agent/Landlord', 
          options: ['Tenant', 'Agent', 'Landlord'] },
        { id: 'receiptDate', type: 'date', label: 'Date' }
      ]
    }
  ]
};
